module.exports = __webpack_public_path__ + "img/Antargaz_120X35.0a0b2125.png";